import { FieldArray } from "@progress/kendo-react-form";
import { UserGroupGrid } from "./DatasetGrid/UserGroup/UserGroupListGrid";
import { datasetData } from "./NewDatasetSignals";

export const UserGroupDataset = ({ formRenderProps }) => {
  return (
    <>
      <div className="white-section">
        <h2>User Group Data</h2>
        <div className="table-input-grid">
          <FieldArray
            name="userGroupGrid"
            component={UserGroupGrid}
            value={datasetData.value.values.map((row) => row)}
            onChange={(newListData) => {
              datasetData.value = { ...datasetData.value, values: newListData };
              formRenderProps.onChange("userGroupGrid", newListData);
            }}
          />
        </div>
      </div>
      {formRenderProps.errors.listGrid && (
        <div className="error">{formRenderProps.errors.listGrid}</div>
      )}
    </>
  );
};
